import { render } from "./ToolBarTargets.vue?vue&type=template&id=1d36d364&scoped=true"
import script from "./ToolBarTargets.vue?vue&type=script&lang=js"
export * from "./ToolBarTargets.vue?vue&type=script&lang=js"

import "./ToolBarTargets.vue?vue&type=style&index=0&id=1d36d364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d36d364"]])

export default __exports__